import { useLocation } from 'wouter';
import { AvatarMenu } from '../components/AvatarMenu';
import type { AuthedUser } from '../lib/auth-types';

/**
 * ToolsTopbar — geteilte gelbe Chrome-Leiste (Logo mittig, Avatar-Menü rechts),
 * genutzt von Launchpad UND ToolsSettings (P1c PR-B). Das AvatarMenu bündelt jetzt
 * „Einstellungen" (→ `/settings/profile`) + „Abmelden"; das klickbare Logo führt
 * zurück zum Launchpad. Muster = TransferShell-Topbar.
 */
export function ToolsTopbar({ user, onLogout }: { user: AuthedUser; onLogout: () => void }) {
  const [, navigate] = useLocation();
  return (
    <header className="border-b border-brand-green-900/10 bg-brand-yellow">
      <div className="mx-auto flex max-w-6xl items-center gap-4 px-6 py-3">
        {/* Leerer Spacer links (flex-1) spiegelt die Aktionen rechts → Logo mittig. */}
        <div className="flex-1" aria-hidden="true" />
        <button
          type="button"
          onClick={() => navigate('/')}
          aria-label="Zu den Anwendungen"
          className="flex items-center gap-2.5 rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-green-500"
        >
          <img src="/greenforce-logo-green.png" alt="GREENFORCE" className="h-9 w-auto select-none" />
          <span className="text-sm font-bold uppercase tracking-widest text-brand-green-700">Tools</span>
        </button>
        <div className="flex flex-1 items-center justify-end">
          <AvatarMenu
            user={user}
            onLogout={onLogout}
            header={
              <>
                <span className="block truncate font-sans text-xs font-semibold text-brand-green-700">
                  {user.displayName || user.email}
                </span>
                {user.displayName ? <span className="block truncate">{user.email}</span> : null}
              </>
            }
            items={[
              {
                kind: 'action',
                id: 'settings',
                label: 'Einstellungen',
                onClick: () => navigate('/settings/profile'),
              },
              { kind: 'action', id: 'logout', label: 'Abmelden', onClick: onLogout, tone: 'danger' },
            ]}
          />
        </div>
      </div>
    </header>
  );
}
